import { render, staticRenderFns } from "./user-permissions.vue?vue&type=template&id=cbc31934&scoped=true"
import script from "./user-permissions.vue?vue&type=script&setup=true&lang=js"
export * from "./user-permissions.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc31934",
  null
  
)

export default component.exports